var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pkss-bg-color"},[_c('SideMenu',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMainMenu),expression:"showMainMenu"}]}),_c('Header'),_c('router-view'),(
      ![
        'onBoarding',
        'ProfileEdit',
        'ProfileFAQ',
        'ProfileDocuments',
        'acceptContract'
      ].includes(_vm.$route.name) &&
        (['offerSearch'].includes(_vm.$route.name) || _vm.loggedIn)
    )?_c('Footer'):_vm._e(),(false)?_c('CookieAlert'):_vm._e(),_c('portal-target',{attrs:{"name":"modals"}}),_c('portal',{attrs:{"to":"modals"}},[(_vm.showSignInModal)?_c('SignIn',{attrs:{"prevent-redirect-on-close":true},on:{"close":function($event){return _vm.$store.commit('app/hideSignInModal')}}}):_vm._e(),(_vm.showGdprModal)?_c('GdprModal',{on:{"close":_vm.closing}}):_vm._e(),_c('AgreementModal'),_c('UpdateAvailabilityModal')],1),_c('notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }